import type { ElementType } from "@react-spring/web";
import type { PropsWithChildren } from "react";
import { tw } from "src/design-system/tw";

export const twStyledInlineDisplayAdStyles = tw(
  // Mobile: negative margin, expanded width/height
  `-m-[4px] h-[calc(100%+8px)] w-[calc(100%+8px)]`,
  "md:m-0 md:h-auto md:w-full",
);

type InlineWrapperProps = {
  hasAd: boolean;
  isListItem?: boolean;
  className?: string;
};

export function TwInlineAdWrapper({
  hasAd,
  isListItem = false,
  className,
  children,
}: PropsWithChildren<InlineWrapperProps>) {
  const Wrapper: ElementType = isListItem ? "li" : "div";

  return (
    <Wrapper
      className={tw(
        hasAd ? "flex" : "hidden",
        "bg-fill-solid",
        !isListItem && "my-2 border border-border-secondary rounded-rounded-md",
        "cursor-pointer overflow-hidden",
        "hover:bg-fill-solid-hover",
        "md:mb-0",
        className,
      )}
    >
      {children}
    </Wrapper>
  );
}
